/**
 *
 * @param {{ rescheduleRules: Ref<string[]>, cancelRules: Ref<string[], isDelivery: Ref<boolean>, isMovie: Ref<boolean> }} param
 */
export function useMutationPolicies(param = {}) {
  const { isMovie = ref(false), isDelivery = ref(false), rescheduleRules = ref([]), cancelRules = ref([]) } = param
  const { $i18n } = useNuxtApp()

  const industry = computed(() => {
    if (isMovie.value) {
      return 'movie'
    }
    if (isDelivery.value) {
      return 'delivery'
    }
    return 'default'
  })

  const policyTitle = computed(() => {
    const titleMap = {
      movie: $i18n.t('cancellation_policy'),
      delivery: $i18n.t('delivery_policy'),
      default: $i18n.t('cancellation_policy'),
    }
    return titleMap[industry.value]
  })

  const rulesPayloads = computed(() =>
    [
      { label: 'all_cancellation_policy_subtitle_changetime', rules: rescheduleRules.value },
      { label: 'all_cancellation_policy_subtitle_cancel', rules: cancelRules.value },
    ].filter(payload => payload.rules.length)
  )

  /** 除了外送，其他退改政策都是來自 API */
  const policyText = computed(() => {
    const policyTextMap = {
      movie: '',
      delivery: $i18n.t('delivery_policy_content'),
      default: '',
    }
    return policyTextMap[industry.value] || ''
  })

  return {
    policyTitle,
    rulesPayloads,
    policyText,
  }
}
